// @ts-nocheck
import * as React from "react";

const Instagram: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M7.87 2.128c-1.628.073-3.04.471-4.179 1.606C2.548 4.874 2.155 6.29 2.081 7.9c-.045 1.006-.313 8.602.463 10.594a5.04 5.04 0 002.91 2.903c.633.246 1.356.412 2.416.461 8.86.401 12.145.183 13.53-3.364.246-.631.415-1.353.462-2.41.405-8.883-.066-10.809-1.61-12.351C19.027 2.512 17.586 1.68 7.87 2.128m.081 17.944c-.97-.043-1.496-.205-1.848-.341a3.255 3.255 0 01-1.888-1.883c-.591-1.514-.395-8.703-.343-9.866.052-1.14.283-2.18 1.087-2.985.995-.992 2.28-1.479 11.034-1.084 1.142.052 2.186.282 2.992 1.084.995.993 1.489 2.288 1.087 11.008-.044.968-.206 1.493-.343 1.843-.9 2.308-2.972 2.628-11.778 2.224M16.09 6.695c0 .657.535 1.19 1.195 1.19s1.195-.533 1.195-1.19a1.194 1.194 0 00-2.39 0m-9.226 5.298a5.103 5.103 0 005.109 5.097 5.103 5.103 0 005.11-5.097 5.102 5.102 0 00-5.11-5.096 5.102 5.102 0 00-5.11 5.096m1.794 0a3.313 3.313 0 013.316-3.308 3.313 3.313 0 013.316 3.308 3.313 3.313 0 01-3.316 3.31 3.313 3.313 0 01-3.316-3.31"
            />
        </svg>
    );
};

export default React.memo(Instagram);
